import { ErrorBoundary, InitWrapper } from '@/lib/components';
import { userTokenParsed } from '@/lib/atoms/atoms';
import { AuthComponent } from '@/lib/route-guards';
import { library } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { ConfigProvider } from 'antd';
import nlNL from 'antd/locale/nl_NL';
import { Provider, useAtomValue } from 'jotai';
import './lib/utils/dayjs';
import { Providers } from './providers';
import { AppRouter } from './router';

library.add(far, fas);

const APP_THEMES = {
  mijnalfaV1: {
    primary: '#EAAB00',
    success: '#44bf40',
  },
  mijnalfa: {
    primary: '#3AB5A7',
    success: '#3AB5A7',
  },
} as const;

const ThemedApp = () => {
  const userToken = useAtomValue(userTokenParsed);
  const theme = APP_THEMES[userToken.theme as keyof typeof APP_THEMES] || APP_THEMES.mijnalfa;

  return (
    <ConfigProvider
      locale={nlNL}
      theme={{
        token: {
          fontFamily: 'Poppins',
          colorPrimary: theme.primary,
          colorInfo: theme.primary,
          colorSuccess: theme.success,
        },
      }}
    >
      <AuthComponent>
        <Providers>
          <InitWrapper>
            <ErrorBoundary>
              <AppRouter />
            </ErrorBoundary>
          </InitWrapper>
        </Providers>
      </AuthComponent>
    </ConfigProvider>
  );
};

export const App = () => {
  return (
    <Provider>
      <ThemedApp />
    </Provider>
  );
};
